module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/moment/moment.js
// module id = PJh5
// module chunks = 25